import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { SessionService } from '@/core/session.service';

export const profileGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  if ((sessionService.settings()?.profiles?.length || 0) > 1) {
    return true;
  } else {
    return router.createUrlTree(['/profile-type']);
  }
};
